


const measurementChannels = {

    Default: 'default',
    Second: 'second',
    Third: 'third',
    Forth: 'forth',
    Fifth: 'fifth',
    Sixth: 'sixth',
    Seventh: 'seventh',
    Eighth: 'eighth',

    match(m1, m2) {
        if(!m1 || !m2)
            return false;
        return (m1.toUpperCase() == m2.toUpperCase());
    },
}


export default measurementChannels